import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=0cb9856e&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=0cb9856e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb9856e",
  null
  
)

export default component.exports